import { pdf } from '@react-pdf/renderer';
import { TimeLogDto, TimeLogStatus } from '../../commonTypes/timelog.types';
import { UserOnProject } from '../../components/TimeSheets/UserOnProject';
import { DateTime, Duration, Interval } from 'luxon';
import { TableTimeLog } from '../../components/TimeSheets/UserOnProject/Table';
import { IDateRange } from '../date/dateHelper';

export const generateUserOnProject = async (
    timeLogs: TimeLogDto[],
    clientName: string,
    memberName: string,
    memberLastName: string,
    projectName: string,
    range: IDateRange
) => {
    if (range.startDate && range.endDate) {
        const interval = Interval.fromDateTimes(range.startDate, range.endDate);

        let totalTime = Duration.fromMillis(0);
        let hoursPerDay = Array(interval.count('days') + 1).fill(0);
        let timeLogsForTable: TableTimeLog[] = [];

        timeLogs.forEach(tl => {
            if (tl.logEnded) {
                const dtLogStarted = DateTime.fromISO(tl.logStarted);
                const dtLogEnded = DateTime.fromISO(tl.logEnded);
                const tlDuration = dtLogEnded.diff(dtLogStarted);

                totalTime = totalTime.plus(tlDuration);
                hoursPerDay[dtLogStarted.day - 1] += tlDuration.as('hours');

                timeLogsForTable.push({
                    id: tl.id,
                    description: tl.description ?? '',
                    duration: tlDuration,
                    logStarted: dtLogStarted.toFormat('dd.MM.yyyy.'),
                    percentage: 0,
                });
            }
        });

        timeLogsForTable = timeLogsForTable.map(tl => {
            const percentageWithDecimals = (100 * tl.duration.toMillis()) / totalTime.toMillis();
            const percentage = Math.round(percentageWithDecimals * 100) / 100;
            return { ...tl, percentage };
        });

        const hasUnsubmittedLogs = timeLogs.some(tl => tl.status === TimeLogStatus.UNSUBMITTED);

        const pdfBlob = await pdf(
            UserOnProject({
                clientName,
                memberLastName,
                memberName,
                period: interval.toFormat('dd.MM.yyyy.'),
                projectName,
                timeLogs: timeLogsForTable,
                totalTime: totalTime.toFormat('hh:mm:ss'),
                diagramProps: { hoursPerDay, interval },
                hasUnsubmittedLogs,
            })
        ).toBlob();

        const url = URL.createObjectURL(pdfBlob);
        window.open(url, '_blank');
    }
};
